import * as React from 'react';

// #region Component Props

interface IProps {
    title       : string;
    icon        : string;
    isExpanded  : boolean;

    // It is open and cannot be closed, as it is one of a few that are all kept open
    isFixed     : boolean;
    controls    : string;
    onClick     : (header : HTMLElement) => void;
}

// #endregion

export const NavbarGroupHeader = (props: IProps) => (
    <h3>
        <button
            type="button"
            className="module-toggle"
            title={ props.title }
            aria-expanded={ props.isExpanded }
            aria-disabled={ props.isFixed ? true : undefined }
            aria-controls={ props.controls }
            onClick={ (e: React.MouseEvent<HTMLButtonElement>) => props.onClick(e.currentTarget) }>
            { props.icon ? <i className={ 'la ' + props.icon } /> : null }
            <span className="module-title">{ props.title }</span>
            <i className="la la-angle-right module-chevron" />
        </button>
    </h3>
);
